import type { BookingDTO, LegDTO } from '@/types/dto/agent';
import { useMemo } from 'react';

export const useBookingTripLegs = (
  booking: BookingDTO | null
): {
  outboundLegs: Array<LegDTO>;
  inboundLegs: Array<LegDTO>;
} => {
  const outboundLegs = useMemo(
    () =>
      booking?.bookedTrips
        ?.filter(({ isOutbound }) => isOutbound)
        .flatMap(({ legs }) => legs || []) || [],
    [booking?.bookedTrips]
  );
  const inboundLegs = useMemo(
    () =>
      booking?.bookedTrips
        ?.filter(({ isOutbound }) => !isOutbound)
        .flatMap(({ legs }) => legs || []) || [],
    [booking?.bookedTrips]
  );

  return {
    outboundLegs,
    inboundLegs,
  };
};
